import React, { useEffect } from 'react';
import { EmbedFrame, isWide } from './embed';
import { PLATFORM_LABEL } from './labels';
import { track } from './track';

// The post's own player (TikTok or Facebook), opened over the page.
const PlayerModal = ({ listing, onClose }) => {
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [onClose]);

  const wide = isWide(listing);
  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label="Lecteur de l'annonce"
      className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center p-4"
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div className="flex flex-col gap-2.5 w-full max-w-[380px] max-h-full">
        <div
          className={`relative w-full overflow-hidden rounded-xl ${wide ? 'bg-white' : 'bg-black aspect-[9/16]'}`}
          style={wide ? { height: 'min(680px, calc(100vh - 110px))' } : { maxHeight: 'calc(100vh - 110px)' }}
        >
          <EmbedFrame listing={listing} />
        </div>
        <div className="flex items-center gap-2.5 text-white text-sm">
          <button type="button" onClick={onClose} className="bg-white/15 hover:bg-white/25 rounded-full px-3 py-1.5">Fermer ✕</button>
          <span className="truncate">{listing.account}</span>
          <a href={listing.url} target="_blank" rel="noopener noreferrer" onClick={() => track('contact', listing)} className="ml-auto text-orange-300 font-semibold whitespace-nowrap">
            Ouvrir sur {PLATFORM_LABEL[listing.platform]} ↗
          </a>
        </div>
      </div>
    </div>
  );
};

export default PlayerModal;
